// extracted by mini-css-extract-plugin
module.exports = {"specialInstructions":"SpecialInstructions__specialInstructions___8m0nx"};